module.exports = __webpack_public_path__ + "static/img/column.8a6f5b62.png";